export default __webpack_public_path__ + "static/media/group-library.8f9fede4.svg";